import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import { useStyles } from './styles';

const RadioGroup = props => {
  const { options: optionGroups, value, onChange } = props;
  const [selected, setSelected] = useState(value);
  const classes = useStyles();
  const firstRender = useRef(true);

  const handleSelect = useCallback((label, value) => {
    setSelected(currentSelect => {
      const newValue = { ...currentSelect, [label]: value };
      return newValue;
    });
  }, []);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      onChange(selected);
    }
  }, [selected]);

  return (
    <div className={classes.filterDropdownBox} data-test-id="dropdown_option_list">
      {optionGroups.map(group => (
        <div key={group.key} className={classes.radioGroupContainer}>
          {group.title && <p className={classes.radioGroupTitle}>{group.title}</p>}
          <Radio.Group
            onChange={e => {
              handleSelect(group.key, e.target.value);
            }}
            value={selected[group.key]}
          >
            {group.options.map(option => (
              <Radio className={classes} key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </div>
      ))}
    </div>
  );
};
RadioGroup.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default RadioGroup;
